import React from 'react'
import { Link } from 'react-router'
import { compose } from 'recompose'

import { generateRoute } from 'utils/routing'

import { withRouter, withRouterProps } from 'services/router'

import { Typography } from 'components'

import i18n from 'translations'

import { StyledContainer, StyledLogo } from '../ButtonsStyled'

interface AppMarketplaceButtonProps {
  onChangeSidebar: (value: boolean) => void
}

const AppMarketplaceButton: React.FC<AppMarketplaceButtonProps & withRouterProps> = ({
  navigate,
  onChangeSidebar,
}) => {
  const handleClick = () => {
    onChangeSidebar(false)
    navigate(generateRoute('APP_MARKETPLACE.INDEX'))
  }

  return (
    <StyledContainer as={Link} onClick={handleClick}>
      <StyledLogo src="/images/app-marketplace-logo.svg" />
      <div>
        <Typography variant="div" bold>
          {i18n.t('module:AppMarketplace:title')}
        </Typography>
      </div>
    </StyledContainer>
  )
}

const enhance = compose(
  withRouter,
)

export default enhance(AppMarketplaceButton)
